import { memo, useState, useCallback } from 'react';
import cn from 'classnames';
import { IconGear } from '@icons';
import Icon from '@components/Icon/Icon';
import KeywordSettings from '@components/KeywordSettings';
import { ByoTableRow } from "../byoTable.helpers";
import { useFilters } from '@vms/SelectFilters/SelectFiltersContext';
import { useByoDataContext } from '@pages/Byo/ByoContext';
import { useAiSearchSettingsContext } from '@vms/AiSearchSettingsContext/AiSearchSettingsContext';
import { KeywordItem } from '@components/KeywordSettings/KeywordSettings';

interface KeywordCellSettingsProps {
    id: number;
    name?: string;
    wordExtensions?: ByoTableRow['wordExtensions'];
}

const KeywordCellSettings = ({
    id,
    name = '',
    wordExtensions,
}: KeywordCellSettingsProps) => {
    const { keywords } = useFilters();
    const { updateKeyword } = useByoDataContext();
    const { resetSearch } = useAiSearchSettingsContext();
    
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [isSettingsShown, setIsSettingsShown] = useState(false);
    
    const extensions = wordExtensions || [];
    
    const applySettings = useCallback((
        _,
        settings: ByoTableRow['wordExtensions']
    ) => {
        updateKeyword(name, { wordExtensions: settings });
        resetSearch();
    }, [updateKeyword, name, resetSearch]);

    const closeModal = useCallback(() => {
        setIsSettingsShown(false);
    }, []);
    
    return (
        <>
            <div
                className="KeywordCell__gear-btn"
                onClick={(event) => {
                    const boundingRect = event.currentTarget.getBoundingClientRect();
                    setPosition({
                        x: boundingRect.right - 10,
                        y: Math.min(window.innerHeight - 150, boundingRect.top + boundingRect.height / 2),
                    });
                    setIsSettingsShown(true);
                }}
            >
                <Icon
                    type='small'
                    className={cn('KeywordCell__gear-btn-icon', {
                        'is-active': extensions.length > 0
                    })}
                >
                    <IconGear />
                </Icon>
            </div>

            <KeywordSettings
                x={position.x}
                y={position.y}
                id={id}
                closeModal={closeModal}
                shown={isSettingsShown}
                includes={extensions.filter(item => item.wordType === 1 || item.wordType === 3)}
                excludes={extensions.filter(item => item.wordType === 2)}
                searchingKeyword={name.replace('"', '')}
                keywords={keywords as KeywordItem[]}
                applySettings={applySettings}
            />
        </>
    );
};

export default memo(KeywordCellSettings);
